"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredPrivateChatsProvider = void 0;
const react_1 = __importStar(require("react"));
const OrganizationContext_1 = require("./OrganizationContext");
const useScrollLock_1 = require("../hooks/useScrollLock"); // Do not shorten this import as it creates a cyclic dependency
const FilteredPrivateChatsContext_1 = require("./FilteredPrivateChatsContext");
const FilteredPrivateChatsProvider = ({ children, }) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const privateChats = selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getFilteredPrivateChatManager();
    const { concurrencySafe } = (0, useScrollLock_1.useScrollLock)();
    const [isChatLoading, setIsChatLoading] = (0, react_1.useState)(false);
    const [reactiveChatData, setReactiveChatData] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        let removeChangeListener;
        if (privateChats) {
            removeChangeListener = privateChats.registerChangeListener((chatsData) => {
                setReactiveChatData(() => ({
                    chatData: chatsData,
                }));
            });
        }
        return () => {
            if (removeChangeListener) {
                removeChangeListener();
            }
        };
    }, [privateChats]);
    const setChatData = (chatData) => {
        setReactiveChatData(() => chatData
            ? { chatData: chatData }
            : undefined);
    };
    const resetChats = () => {
        setChatData({
            chats: [],
            hasNext: false,
            searchMatchCount: undefined,
            unreadChatCount: 0,
            totalUnreadChatCount: 0,
            limit: 0,
        });
    };
    const fetchChats = (filters_1, ...args_1) => __awaiter(void 0, [filters_1, ...args_1], void 0, function* (filters, newFetch = false, context) {
        if ((newFetch || !reactiveChatData || reactiveChatData.chatData.hasNext) &&
            privateChats) {
            const runner = () => __awaiter(void 0, void 0, void 0, function* () {
                setIsChatLoading(true);
                if (newFetch) {
                    resetChats();
                }
                yield privateChats.filterChats(filters, context);
                setChatData(privateChats.getChats());
                setIsChatLoading(false);
            });
            if (newFetch) {
                yield runner();
            }
            else {
                yield concurrencySafe(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield runner();
                }));
            }
        }
    });
    return (react_1.default.createElement(FilteredPrivateChatsContext_1.FilteredPrivateChatsContext.Provider, { value: {
            chatData: reactiveChatData === null || reactiveChatData === void 0 ? void 0 : reactiveChatData.chatData,
            setChatData,
            isChatLoading,
            fetchChats,
            resetChats,
        } }, children));
};
exports.FilteredPrivateChatsProvider = FilteredPrivateChatsProvider;
